export default __webpack_public_path__ + "static/media/Textlog.d5161e96.png";